// gsap animations for heading
const gsapCardRowIntroContentAnimations = () => {
	const wrapper = document.querySelectorAll(".card-row-intro-content__content-wrapper");

	if (!wrapper.length) return;

	// Animate card-row-intro-content heading
	const animateHeading = () => {
		wrapper.forEach((wrapper) => {
			const heading = wrapper.querySelector(".card-row-intro-content__heading-text");

			if (heading) {
			gsap.set(heading, {
				opacity: 0,
				y: 30,
			});

			ScrollTrigger.create({
				trigger: heading,
				start: "top 90%",
				end: "bottom 80%",
				onEnter: () => {
					gsap.to(heading, {
						opacity: 1,
						y: 0,
						duration: 1,
						ease: "power2.out",
					});
					},
				});
			}
		});
	};

	// Animate card-row-intro-content content
	const animateContent = () => {
		wrapper.forEach((wrapper) => {
			const content = wrapper.querySelectorAll(".card-row-intro-content__content > *");

			if (content.length > 0) {
			gsap.set(content, {
				opacity: 0,
				y: 30,
			});

			ScrollTrigger.batch(content, {
				start: "top 95%",
				end: "bottom 20%",
				onEnter: (elements) => {
					gsap.to(elements, {
						opacity: 1,
						y: 0,
						duration: 1,
						stagger: 0.30,
						ease: "power2.out",
					});
					},
				});
			}
		});
	};

	animateHeading();
	animateContent();
};

// Initialize everything when DOM is ready
if (document.readyState !== "loading") {
	gsapCardRowIntroContentAnimations();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		gsapCardRowIntroContentAnimations();
	});
}
